/**
 * Created by shubham on 10/5/18.
 */

/**
 * A model for an individual corporate employee
 */
export class ManagerListDashboard {
    buAssociationId: string;
    Name: string;
    email: string;
    emailVerified: boolean;
    userId_WPASS: string;
    pendingSubUserCount: string;
    applicationName: string;
    countryId: string;
    countryName: string;
    businessUnitId: string;
    businessUnitName: string;
    active: boolean;
    status: string;
    createdAt: string;

    constructor(buAssociationId:string, Name:string, email:string, emailVerified:boolean, userId_WPASS:string, pendingSubUserCount:string,
                applicationName: string, countryId:string, countryName: string, businessUnitId: string, businessUnitName: string, active: boolean, status: string, createdAt: string){
        this.buAssociationId = buAssociationId;
        this.Name = Name;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.applicationName = applicationName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.businessUnitId = countryId;
        this.businessUnitName = countryName;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerList-datatable/managerList-dashboard.ts